import { appHttpService } from '@/services/standard/http-service';
import type { models } from 'cesg-shared';

class OutlookInboxService {
  async deleteInboxDocument(doc: models.InboxDocument): Promise<void> {
    await appHttpService.request
      .url(`/outlook-inbox/inbox/${doc.id}`)
      .json({})
      .delete()
      .res();
  }
  async getAllSyncedInboxDocuments(): Promise<models.InboxListResponse> {
    const inboxDocuments = await appHttpService.request
      .url('/outlook-inbox/inbox')
      .get()
      .json<models.InboxListResponse>();

    return inboxDocuments;
  }
  async getSyncedInboxDocumentDetails(
    id: string,
  ): Promise<models.InboxDocumentDetail> {
    const inboxDocumentDetailed = await appHttpService.request
      .url(`/outlook-inbox/inbox/${id}`)
      .get()
      .json<models.InboxDocumentDetail>();

    return inboxDocumentDetailed;
  }
  async syncOutlookInbox(): Promise<void> {
    await appHttpService.request.url('/outlook-inbox/inbox/sync').post().res();
  }
}

export const outlookInboxService = new OutlookInboxService();
